import {
  Card,
  CardContent,
  Container,
  Switch,
  Typography,
} from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../../components/pageTitle/PageTitle";
import styles from "../Accounts.module.scss";
import { useMediaQuery } from "@mui/material";
import {
  getSettings,
  resetSettings,
  saveSettings,
  updateSettings,
} from "../../../services/apiservices/settings";
import AuthContext from "../../../hooks/authContext";
import CommonContext from "../../../hooks/commonContext";
import {
  CommonConfirmationDialog,
  CommonSuccessDialog,
} from "../../../components/DialogComponent/SupplyDataDialog";
import { useNavigate } from "react-router";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import { useToast } from "../../../hooks/useToast";
import SingleSelectNew from "../../../components/SelectField/SingleSelectNew";
import MultiSelectWithCheckbox from "../../../components/SelectField/MulitpleSelectNew";

const SaveIndicator = ({ isLoading, isSuccess }) => {
 if (isLoading) {
    return (
      <div className="d-flex flex-center mt-8 mh-10" style={{ gap: "8px" }}>
        <div
          className="spinner-border"
          role="status"
          style={{
            width: "22px",
            height: "22px",
            borderWidth: "2.5px",
            borderColor: "#2980ba transparent #2980ba transparent",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        {/* <span style={{ fontSize: "14px", color: "#64748B" }}>Saving...</span> */}

        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  if (isSuccess) {
    return (
      <div
        className="d-flex flex-center mt-8"
        style={{
          gap: "8px",
          color: "#22C55E",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            backgroundColor: "#DCFCE7",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 0 4px rgba(34,197,94,0.3)",
          }}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 16 16"
            fill="none"
            style={{ display: "block" }}
          >
            <path
              d="M13.3337 4L6.00033 11.3333L2.66699 8"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <span style={{ fontSize: "15px", color: "#22C55E" }}>Saved</span>
      </div>
    );
  }

  return null;
};


const IssuePageSetting = () => {
  const auth = useContext(AuthContext);
  const commonContext = useContext(CommonContext);
  const [autoArchiveRequest, setAutoArchiveRequest] = useState("notAllowed");
  const [archiveRequestRole, setArchiveRequestRole] = useState([]);
  const [internamManagersRoles, setInternalManagersRole] = useState([]);
  const [escalateRequestRole, setEscalateRequestRole] = useState([]);
  const [publicPageType, setPublicPageType] = useState(false);
  const [error, setError] = useState({});
  const [data, setData] = useState();
  const [open, setOpen] = useState(false);
  const [updateOpen, setUpdateOpen] = useState(false);
  const [resetOpen, setResetOpen] = useState(false);
  const [resetSuccessOpen, setResetSuccessOpen] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const autoArchiveOptions = [
    { label: "Not Allowed", value: "notAllowed" },
    { label: "15 Days", value: "15 Days" },
    { label: "30 Days", value: "30 Days" },
    { label: "60 Days", value: "60 Days" },
    { label: "90 Days", value: "90 Days" },
  ];

  const Roles = [
    { label: "ADMIN", value: "admin" },
    { label: "SUPPORT", value: "support" },
  ];

  const [loadingStates, setLoadingStates] = useState({
    autoArchive: false,
    archiveRole: false,
    escalateRole: false,
    publicPage: false,
    internalManagers: false
  });

  const [saveSuccess, setSaveSuccess] = useState({
    autoArchive: false,
    archiveRole: false,
    escalateRole: false,
    publicPage: false,
    internalManagers: false
  });

  const isMobile = useMediaQuery("(max-width:767px)");
  // eslint-disable-next-line no-unused-vars
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );

  const fetchSettings = () => {
    const companyId =
    auth?.userProfile?.role === "companyUser"
    ? auth?.userProfile?.id
    : auth?.userProfile?.companyId;
    
    getSettings("issue_settings", companyId, (res) => {
      if (res?.data) {
        const filteredData = res.data.filter(
          (item) => !item.deleted
        );

        if (filteredData.length > 0) {
          const [firstItem] = filteredData;
          setData(filteredData);
          setAutoArchiveRequest(firstItem?.autoArchiveRequest);
          setArchiveRequestRole(firstItem?.archiveRequestRole);
          setEscalateRequestRole(firstItem?.escalateRequestRole);
          setInternalManagersRole(firstItem?.internamManagersRoles);
          setPublicPageType(firstItem?.publicPageType === "Yes" ? true : false);
        } else {
          setData();
          setAutoArchiveRequest("notAllowed");
          setArchiveRequestRole([]);
          setEscalateRequestRole([]);
          setInternalManagersRole([]);
          setPublicPageType(false);
        }
      } else {
        setData();
        setAutoArchiveRequest("notAllowed");
        setArchiveRequestRole([]);
        setEscalateRequestRole([]);
        setInternalManagersRole([]);
        setPublicPageType(false);
      }
    });
  };

  useEffect(() => {
    fetchSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // fetchSettings is stable, no need to include in deps

  const validFields = () => {
    const errormessages = {};
    let isValid = true;

    if (
      !autoArchiveRequest &&
      (!archiveRequestRole?.length || archiveRequestRole.length === 0) &&
      (!escalateRequestRole?.length || escalateRequestRole.length === 0) &&
      (!internamManagersRoles?.length || internamManagersRoles.length === 0)
    ) {
      isValid = false;
      errormessages.autoArchiveRequest = "Auto Archive Request is Required";
      errormessages.archiveRequestRole = "Archive Request Role is Required";
      errormessages.escalateRequestRole = "Escalate Request Role is Required";
      errormessages.internamManagersRoles = "Internal Manager Role is Required";
    }

    setError(errormessages);
    return isValid;
  };

 const handleSaveData = async (field, value) => {
   setLoadingStates((prev) => ({ ...prev, [field]: true }));
   setSaveSuccess((prev) => ({ ...prev, [field]: false }));

   if (!validFields()) {
     setLoadingStates((prev) => ({ ...prev, [field]: false }));
     return;
   }

   try {
     const companyId =
       auth?.userProfile?.role === "companyUser"
         ? auth?.userProfile?.id
         : auth?.userProfile?.companyId;

     const dataToSave = {
       autoArchiveRequest: field === "autoArchive" ? value : autoArchiveRequest,
       archiveRequestRole: field === "archiveRole" ? value : archiveRequestRole,
       escalateRequestRole:
         field === "escalateRole" ? value : escalateRequestRole,
       internamManagersRoles:
         field === "internalManagers" ? value : internamManagersRoles,
       publicPageType:
         field === "publicPage"
           ? value
             ? "Yes"
             : "No"
           : publicPageType
           ? "Yes"
           : "No",
       companyId,
     };

     let response;
     if (data?.length > 0) {
       const id = data[0]?.id;
       response = await updateSettings(dataToSave, "issue_settings", id);
     } else {
       response = await saveSettings(dataToSave, "issue_settings");
     }

     if (response?.status === true) {
       setSaveSuccess((prev) => ({ ...prev, [field]: true }));

       toast?.({
         title: "Success",
         description:
           data?.length > 0
             ? "Settings updated successfully"
             : "Settings saved successfully",
       });

       setTimeout(() => {
         setSaveSuccess((prev) => ({ ...prev, [field]: false }));
       }, 2000);

       await fetchSettings();
     }
   } catch (error) {
     console.error("Auto-save error:", error);
     toast?.({
       title: "Error",
       description: "Failed to save settings",
       variant: "destructive",
     });
   } finally {
     setLoadingStates((prev) => ({ ...prev, [field]: false }));
   }
 };

 const handleAutoRequestChange = (e) => {
   setAutoArchiveRequest(e);
   handleSaveData("autoArchive", e);
 };

 const handleArchiveRequestRoleChange = (e) => {
   setArchiveRequestRole(e);
   handleSaveData("archiveRole", e);
 };

 const handleInternalManagerRoleChange = (e) => {
   setInternalManagersRole(e);
   handleSaveData("internalManagers", e);
 };

 const handleEscalateRequestRoleChange = (e) => {
   setEscalateRequestRole(e);
   handleSaveData("escalateRole", e);
 };

 const handlePublicPageToggle = () => {
   const newValue = !publicPageType;
   setPublicPageType(newValue);
   handleSaveData("publicPage", newValue);
 };

  // eslint-disable-next-line no-unused-vars
  const handleUpdateData = async () => {
    commonContext?.setLoader(true);
    if (!validFields()) {
      commonContext?.setLoader(false);
      return;
    } else {
      const dataToSave = {
        autoArchiveRequest: autoArchiveRequest,
        archiveRequestRole: archiveRequestRole,
        escalateRequestRole: escalateRequestRole,
        internamManagersRoles: internamManagersRoles,
        publicPageType: publicPageType === true ? "Yes" : "No",
      };
      const id = data[0]?.id;

      const details = await updateSettings(dataToSave, "issue_settings", id);
      if (details.status === true) {
        commonContext?.setLoader(false);
        fetchSettings();
        toast?.({ title: "Success", description: "Setting Update Successfully" });
      }
      commonContext?.setLoader(false);
    }
  };

  const handleResetConfirm = async () => {
    setResetOpen(false);
    commonContext?.setLoader(true);
    const id = data[0]?.id;
    const details = await resetSettings("issue_settings", id);
    if (details.status === true) {
      commonContext?.setLoader(false);
      fetchSettings();
      toast?.({ title: "Success", description: "Setting Reset Successfully" });
    }
    commonContext?.setLoader(false);
  };

  const handleResetClose = () => {
    setResetOpen(false);
  };

  const handleResetSuccessClose = () => {
    setResetSuccessOpen(false);
    fetchSettings();
    toast?.({ title: "Success", description: "Setting Reset Successfully" });
  };

  const handleColse = () => {
    setOpen(false);
    navigate("/account/settings");
    toast?.({ title: "Success", description: "Setting Saved Successfully" });
  };

  const handleUpdateClose = () => {
    setUpdateOpen(false);
    navigate("/account/settings");
    toast?.({ title: "Success", description: "Setting Update Successfully" });
  };

  // eslint-disable-next-line no-unused-vars
  const handleReset = () => {
    if (data?.length > 0) {
      setResetOpen(true);
    } else {
      setData();
      setAutoArchiveRequest("notAllowed");
      setArchiveRequestRole([]);
      setEscalateRequestRole([]);
      setInternalManagersRole([]);
      setPublicPageType(false);
      setError({});
    }
  };

  return (
    <>
      <Container>
        <PageTitle
          pageTitle={`Issue Settings`}
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Settings", to: "/account/settings" },
          ]}
          BreadCrumbCurrentPageTitle={"Issue"}
          showLastSeen={true}
        />
        <div className="pt-30">
          <div
            style={{
              maxWidth: isMobile ? "390px " : "1080px",
              margin: "0 auto",
            }}
          >
            <div className="d-flex flex-direction-column gap-4">
              <div
                className="mb-18 d-flex flex-direction-column"
                style={{ paddingLeft: isMobile ? "0px" : "65px", gap: "12px" }}
              >
                <h2 className="dark:text-white">Issue Settings</h2>
                <p style={{ color: "#64748B", marginTop: "12px" }}>
                  Configure how issues are managed across your organization.
                </p>
              </div>
              <div
                className={
                  isMobile
                    ? "d-flex flex-direction-column flex-center "
                    : "d-flex flex-justify-center flex-center gap-4 "
                }
              >
                <Card
                  className={
                    isMobile
                      ? `${styles.issuesCard} mv-28 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`
                      : `${styles.issuesCard} mh-28 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`
                  }
                >
                  <div className="p-16 ">
                    <div className="d-flex flex-center" style={{ gap: "8px" }}>
                      <div
                        className={`${styles.cardIconBbox} ${styles.iconBlue} dark:bg-gray-800`}
                      >
                        <Inventory2OutlinedIcon
                          style={{
                            color:
                              "rgba(59, 130, 246, var(--tw-text-opacity, 1))",
                          }}
                        />
                      </div>
                      <Typography
                        variant="body"
                        className={`${styles.issuescardTitle} dark:text-white`}
                      >
                        Auto Archive Request
                      </Typography>
                      <div className="ml-auto">
                        <SaveIndicator isLoading={loadingStates?.autoArchive} isSuccess={saveSuccess?.autoArchive} />
                      </div>
                    </div>
                    <div className="mt-10">
                      <Typography
                        variant="body"
                        className={styles.issuescardDescription}
                      >
                        Control how issues are automatically archived
                      </Typography>
                    </div>
                  </div>
                  <CardContent style={{ padding: "0px 24px 24px" }}>
                    <Typography
                      className="dark:text-white"
                      variant="body"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                      }}
                    >
                      Auto Archive Setting
                    </Typography>
                    <div className="mv-12">
                      <SingleSelectNew
                        contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                        itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                        value={autoArchiveRequest}
                        name="autoArchiveRequest"
                        onChange={handleAutoRequestChange}
                        options={autoArchiveOptions}
                      />
                      {error.autoArchiveRequest && (
                        <span className="d-flex small error color-danger">
                          {error.autoArchiveRequest}
                        </span>
                      )}
                    </div>
                    <Typography
                      variant="body"
                      style={{
                        color: "#64748B",
                        fontWeight: "400",
                        lineHeight: "24px",
                        fontSize: "14px",
                      }}
                    >
                      Choose how issues are automatically archived. When
                      automatic is selected, issues will be archived after 30
                      days of inactivity.
                    </Typography>
                  </CardContent>
                </Card>

                <Card
                  className={
                    isMobile
                      ? `${styles.issuesCard} mv-28 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`
                      : `${styles.issuesCard} mh-28 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`
                  }
                >
                  <div className="p-16">
                    <div className="d-flex flex-center" style={{ gap: "8px" }}>
                      <div
                        className={`${styles.cardIconBbox} ${styles.iconBlue} dark:bg-gray-800 bg-#FAF5FF`}
                        // style={{ background: "#FAF5FF" }}
                      >
                        <Inventory2OutlinedIcon
                          style={{ color: "rgb(168, 85, 247)" }}
                        />
                      </div>
                      <Typography
                        variant="body"
                        className={`${styles.issuescardTitle} dark:text-white`}
                      >
                        Archive Request Role
                      </Typography>
                      <div className="ml-auto">
                      <SaveIndicator isLoading={loadingStates?.archiveRole} isSuccess={saveSuccess?.archiveRole} />
                      </div>
                    </div>
                    <div className="mt-10">
                      <Typography
                        variant="body"
                        className={styles.issuescardDescription}
                      >
                        Define which roles can archive issues
                      </Typography>
                    </div>
                  </div>
                  <CardContent style={{ padding: "0px 24px 24px" }}>
                    <Typography
                     className="dark:text-white"
                      variant="body"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                      }}
                    >
                      Archive Permission Role
                    </Typography>
                    <div className="mv-12">
                       <MultiSelectWithCheckbox
                        value={archiveRequestRole}
                        name="archiveRequestRole"
                        onChange={handleArchiveRequestRoleChange}
                        options={Roles}
                        selectAllOption
                        defaultSelectAll
                        defaultValue={setArchiveRequestRole}
                      />
                      {error.archiveRequestRole && (
                        <span className="d-flex small error color-danger">
                          {error.archiveRequestRole}
                        </span>
                      )}
                    </div>
                    <Typography
                      variant="body"
                      style={{
                        color: "#64748B",
                        fontWeight: "400",
                        lineHeight: "24px",
                        fontSize: "14px",
                      }}
                    >
                      Select which user roles have permission to manually
                      archive issues in the system.
                    </Typography>
                  </CardContent>
                </Card>
              </div>

              <div
                className={
                  isMobile
                    ? "d-flex flex-direction-column flex-center"
                    : "d-flex flex-justify-center flex-center mv-18 pv-18 gap-4"
                }
              >
                <Card
                  className={
                    isMobile
                      ? `${styles.issuesCard} mv-28 dark:bg-[#1A1F2C] dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`
                      : `${styles.issuesCard} mh-28 dark:bg-[#1A1F2C] dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`
                  }
                >
                  <div className="p-16">
                    <div className="d-flex flex-center" style={{ gap: "8px" }}>
                      <div
                        className={`${styles.cardIconBbox} ${styles.iconBlue} bg-#FAFBEB dark:bg-gray-800`}
                        // style={{ background: "#FAFBEB" }}
                      >
                        <ArrowOutwardOutlinedIcon
                          style={{ color: "rgba(245, 158, 11, 1)" }}
                        />
                      </div>
                      <Typography
                        variant="body"
                        className={`${styles.issuescardTitle} dark:text-white`}
                      >
                        Escalate Request Role
                      </Typography>
                      <div className="ml-auto">
                      <SaveIndicator isLoading={loadingStates?.escalateRole} isSuccess={saveSuccess?.escalateRole} />
                      </div>
                    </div>
                    <div className="mt-10">
                      <Typography
                        variant="body"
                        className={styles.issuescardDescription}
                      >
                        Define which roles can escalate issues
                      </Typography>
                    </div>
                  </div>
                  <CardContent style={{ padding: "0px 24px 24px" }}>
                    <Typography
                    className="dark:text-white"
                      variant="body"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                      }}
                    >
                      Escalation Permission Role
                    </Typography>
                    <div className="mv-12">
                       <MultiSelectWithCheckbox
                        value={escalateRequestRole}
                        name="escalateRequestRole"
                        onChange={handleEscalateRequestRoleChange}
                        options={Roles}
                        selectAllOption
                        defaultSelectAll
                        defaultValue={setEscalateRequestRole}
                      />
                      {error.escalateRequestRole && (
                        <span className="d-flex small error color-danger">
                          {error.escalateRequestRole}
                        </span>
                      )}
                    </div>
                    <Typography
                      variant="body"
                      style={{
                        color: "#64748B",
                        fontWeight: "400",
                        lineHeight: "24px",
                        fontSize: "14px",
                      }}
                    >
                      Select which user roles have permission to escalate issues
                      to higher priority.
                    </Typography>
                  </CardContent>
                </Card>

                <Card
                  className={
                    isMobile
                      ? `${styles.issuesCard} mv-28 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`
                      : `${styles.issuesCard} mh-28 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`
                  }
                >
                  <div className="p-16">
                    <div
                      className="d-flex flex-space-between flex-center"
                      style={{ gap: "8px" }}
                    >
                      <div className="d-flex flex-center">
                        <div
                          className={`${styles.cardIconBbox} ${styles.iconGreen} mr-10 bg-[#F0FDF4] dark:bg-gray-800`}
                        >
                          <ErrorOutlineOutlinedIcon
                            style={{ color: "rgba(34, 197, 94, 1)" }}
                          />
                        </div>
                        <Typography
                          variant="body"
                          className={`${styles.issuescardTitle} dark:text-white`}
                        >
                          Enable Public Page View
                        </Typography>
                      </div>
                      <Switch
                        checked={publicPageType}
                        onChange={handlePublicPageToggle}
                        color="primary"
                      />
                    </div>
                    <Typography className={styles.issuescardDescription}>
                      Allow issues to be viewed publicly without authentication
                    </Typography>
                    <div className="mv-18">
                      <Typography
                        variant="body"
                        style={{
                          color: "#64748B",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontSize: "14px",
                        }}
                      >
                        When enabled, issues can be viewed by anyone with the
                        public link without requiring authentication.
                      </Typography>
                    </div>
                    <SaveIndicator isLoading={loadingStates?.publicPage} isSuccess={saveSuccess?.publicPage} />
                  </div>
                </Card>
              </div>
              <div
                className={
                  isMobile
                    ? "d-flex flex-direction-column flex-center"
                    : "d-flex flex-justify-start flex-center gap-4 mb-40"
                }
              >
                <Card
                  className={
                    isMobile
                      ? `${styles.issuesCard} mv-28 dark:bg-[#1A1F2C] dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`
                      : `${styles.issuesCard} mr-28 dark:bg-[#1A1F2C] dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`
                  }
                  style={{marginLeft: isMobile ? "" : "55px"}}
                >
                  <div className="p-16">
                    <div className="d-flex flex-center" style={{ gap: "8px" }}>
                      <div
                        className={`${styles.cardIconBbox} ${styles.iconBlue} bg-#FAFBEB dark:bg-gray-800`}
                        // style={{ background: "#FAFBEB" }}
                      >
                        <Inventory2OutlinedIcon
                          style={{color : "rgba(59, 130, 246, var(--tw-text-opacity, 1))", }}
                        />
                      </div>
                      <Typography
                        variant="body"
                        className={`${styles.issuescardTitle} dark:text-white`}
                      >
                        Assign Internal Managers
                      </Typography>
                      <div className="ml-auto">
                        <SaveIndicator isLoading={loadingStates?.internalManagers} isSuccess={saveSuccess?.internalManagers} />
                      </div>
                    </div>
                    <div className="mt-10">
                      <Typography
                        variant="body"
                        className={styles.issuescardDescription}
                      >
                        Assign roles for your internal managers. These roles will receive issue updates when they are added to an issue (for all clients).
                      </Typography>
                    </div>
                  </div>
                  <CardContent style={{ padding: "0px 24px 24px" }}>
                    <Typography
                    className="dark:text-white"
                      variant="body"
                      style={{
                        fontWeight: "500",
                        fontSize: "14px",
                      }}
                    >
                      Assign Internal Managers  (by role)
                    </Typography>
                    <div className="mt-12 mb-12">
                       <MultiSelectWithCheckbox
                        value={internamManagersRoles}
                        name="internalManagersRole"
                        onChange={handleInternalManagerRoleChange}
                        options={Roles}
                        selectAllOption
                        defaultSelectAll
                        defaultValue={setInternalManagersRole}
                      />
                      {error.internamManagersRoles && (
                        <span className="d-flex small error color-danger">
                          {error.internamManagersRoles}
                        </span>
                      )}
                    </div>
                    <Typography
                      variant="body"
                      style={{
                        color: "#64748B",
                        fontWeight: "400",
                        lineHeight: "24px",
                        fontSize: "14px",
                      }}
                    >
                      Select user roles to designate as internal managers. They will receive updates for all assigned issues.
                    </Typography>
                  </CardContent>
                </Card>
              </div>
              {/* <div
                className="d-flex flex-justify-start mv-25"
                style={{ paddingLeft: isMobile ? "0px" : "60px", gap: "12px" }}
              >
                <Button
                  variant="contained"
                  style={{ boxShadow: "none",backgroundColor:"#078037",color:"white" }}
                  onClick={data ? handleUpdateData : handleSaveData}
                >
                  {data ? "Update" : "Save"}
                </Button>
                <Button
                  variant="contained"
                  color="default"
                  style={{ marginLeft: 10, boxShadow: "none" }}
                  onClick={() => navigate("/account/settings")}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  style={{ marginLeft: 10, boxShadow: "none" }}
                  onClick={handleReset}
                >
                  Reset
                </Button>
              </div> */}
            </div>
          </div>
        </div>
      </Container>
      {open && (
        <CommonSuccessDialog
          open={open}
          onClose={handleColse}
          title={"Success"}
          message={"Your settings have been successfully saved."}
        />
      )}
      {updateOpen && (
        <CommonSuccessDialog
          open={updateOpen}
          onClose={handleUpdateClose}
          title={"Success"}
          message={"Your settings have been successfully update."}
        />
      )}
      {resetOpen && (
        <CommonConfirmationDialog
          open={resetOpen}
          onConfirm={handleResetConfirm}
          onClose={handleResetClose}
          title={"Setting Reset"}
          message={"Are you sure you want to reset the settings?"}
          buttonTitle={"Yes"}
        />
      )}
      {resetSuccessOpen && (
        <CommonSuccessDialog
          open={resetSuccessOpen}
          onClose={handleResetSuccessClose}
          title={"Success"}
          message={"Your settings have been successfully reset."}
        />
      )}
    </>
  );
};

export default IssuePageSetting;
